// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerLineNumberAndNotesStyles } from "@rpsc/App/Components/Cart/CustomerLineNumberAndNotes";
import cartLineSharedStyles from "@rpsc/App/SharedStyles/CartLineSharedStyles";
import { xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

customerLineNumberAndNotesStyles.wrapper = {
    css: css`
        margin-top: 12px;
        ${xScreen("lte", "md")} {
            margin-top: 0;
        }
    `,
};
customerLineNumberAndNotesStyles.lineNotesLinkAdd = {
    ...cartLineSharedStyles.lineNotesLinkAdd,
};

customerLineNumberAndNotesStyles.lineNotesLinkHide = {
    ...cartLineSharedStyles.lineNotesLinkHide,
};

customerLineNumberAndNotesStyles.lineNotesModalStyles = {
    sizeVariant: "small",
};

customerLineNumberAndNotesStyles.cancelButton = {
    variant: "tertiary",
};

customerLineNumberAndNotesStyles.modalWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 10px;
    `,
};

customerLineNumberAndNotesStyles.customerLineNumberWrapper = {
    ...cartLineSharedStyles.infoWrapper,
};

customerLineNumberAndNotesStyles.customerLineNumberText = {
    ...cartLineSharedStyles.infoText,
};

customerLineNumberAndNotesStyles.customerLineNumberHeading = {
    ...cartLineSharedStyles.infoHeading,
};

customerLineNumberAndNotesStyles.infoWrapper = {
    ...cartLineSharedStyles.contentWrapper,
};

customerLineNumberAndNotesStyles.buttonsWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        align-items: center;
    `,
};
customerLineNumberAndNotesStyles.cartLineNotes = {
    editableNotesTextArea: {
        css: css`
            resize: vertical;
        `,
    },
};
